import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=ae8bc920&scoped=true"
import script from "./DashboardList.vue?vue&type=script&lang=js"
export * from "./DashboardList.vue?vue&type=script&lang=js"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=ae8bc920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8bc920",
  null
  
)

export default component.exports